import { CreatorContextDispatch } from 'controllers/business/Creator/Creator.types';
import { IPurchaseContext } from 'controllers/business/Purchase/Purchase.types';
import { useDownloadClickHandler } from 'hooks/useDownloadClickHander/useDownloadClickHander';
import { CreatorDownloadSource } from 'types';
import { DownloadType } from 'types/enums';

type UseClickHandlers = ({
    hide,
    openShareModal,
    creatorDownloadSource,
    dispatch,
}: {
    hide: () => void;
    openShareModal: () => void;
    creatorDownloadSource: CreatorDownloadSource;
    dispatch: CreatorContextDispatch;
    purchaseController: IPurchaseContext;
}) => {
    handleShareClick: () => void;
    handleDownloadFullTrackClick: (e: React.MouseEvent) => void;
    handleDownloadSamplesClick: (e: React.MouseEvent) => void;
    handleAddSamplesToCollectionClick: () => void;
};

export const useClickHandlers: UseClickHandlers = ({
    hide,
    openShareModal,
    creatorDownloadSource,
    purchaseController,
    dispatch,
}) => {
    const handleShareClick = (): void => {
        openShareModal();
        hide();
    };

    const handleDownloadFullTrack = useDownloadClickHandler({
        item: { ...creatorDownloadSource, type: DownloadType.CreatorMixdown },
        purchaseController,
    });

    const handleDownloadSamples = useDownloadClickHandler({
        item: creatorDownloadSource,
        purchaseController,
    });

    const handleDownloadFullTrackClick = (e: React.MouseEvent): void => {
        hide();

        dispatch({
            type: 'newInstrumentationSessionId',
        });

        handleDownloadFullTrack(e);
    };

    const handleDownloadSamplesClick = (e: React.MouseEvent): void => {
        hide();

        dispatch({
            type: 'newInstrumentationSessionId',
        });

        handleDownloadSamples(e);
    };

    const handleAddSamplesToCollectionClick = (): void =>
        dispatch({ type: 'newInstrumentationSessionId' });

    return {
        handleShareClick,
        handleDownloadFullTrackClick,
        handleDownloadSamplesClick,
        handleAddSamplesToCollectionClick,
    };
};
